<template>
  <div class="AtlasMapLegend">
    <template v-if="minValue !== maxValue">
      {{ parsedMinValue }}
      <div
        class="AtlasMapLegend-gradient"
        :style="{
          background: `linear-gradient(to right, ${scheme.join(', ')})`,
        }"
      ></div>
      {{ parsedMaxValue }}
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'atlas-map-legend',

  props: {
    scheme: {
      type: Array,
      default: () => ['#F8FAE9', '#BBD239', '#13B6EA'],
    },

    formatString: {
      type: String,
      default: '.0%',
    },

    prefix: {
      type: String,
      default: '',
    },

    suffix: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters('breakdown', ['minValue', 'maxValue']),

    format() {
      return this.$format(this.formatString);
    },
    parsedMinValue() {
      return `${this.prefix}${this.format(this.minValue)}${this.suffix}`;
    },
    parsedMaxValue() {
      return `${this.prefix}${this.format(this.maxValue)}${this.suffix}`;
    },
  },
};
</script>

<style lang="scss">
.AtlasMapLegend {
  padding: 1px $gutter 15px;
  font-size: 13px;

  &-gradient {
    @include size(160px, 13px);
    position: relative;
    top: -1px;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
